export const normalizeSocialHandle = (handle: string, platform: 'instagram' | 'tiktok'): string => {
  // Remove any URL parts
  let cleaned = handle.trim()
    .replace(/https?:\/\/(www\.)?/g, '')
    .replace(`${platform}.com/`, '')
    .replace('@', '');

  // Remove trailing slashes
  cleaned = cleaned.replace(/\/+$/, '');

  return cleaned;
};

// Helper to generate full URLs
export const getSocialUrl = (handle: string, platform: 'instagram' | 'tiktok'): string => {
  const normalized = normalizeSocialHandle(handle, platform);
  switch (platform) {
    case 'instagram':
      return `https://www.instagram.com/${normalized}`;
    case 'tiktok':
      return `https://www.tiktok.com/@${normalized}`;
    default:
      return '';
  }
}; 